import { createI18n } from "vue-i18n";
import af from './af.json';
import am from './am.json';
import ar from './ar.json';
import az from './az.json';
import bg from './bg.json';
import bn from './bn.json';
import bs from './bs.json';
import ca from './ca.json';
import cs from './cs.json';
import cy from './cy.json';
import da from './da.json';
import de from './de.json';
import el from './el.json';
import en from './en.json';
import es from './es.json';
import et from './et.json';
import fa from './fa.json';
import fi from './fi.json';
import fil from './fil.json';
import fr from './fr.json';
import ga from './ga.json';
import gu from './gu.json';
import ha from './ha.json';
import he from './he.json';
import hi from './hi.json';
import hr from './hr.json';
import ht from './ht.json';
import hu from './hu.json';
import hy from './hy.json';
import id from './id.json';
import is from './is.json';
import ja from './ja.json';
import ka from './ka.json';
import kk from './kk.json';
import kn from './kn.json';
import ko from './ko.json';
import it from './it.json';
import lv from './lv.json';
import mk from './mk.json';
import ml from './ml.json';
import mn from './mn.json';
import mr from './mr.json';
import ms from './ms.json';
import mt from './mt.json';
import nl from './nl.json';
import no from './no.json';
import pa from './pa.json';
import pl from './pl.json';
import ps from './ps.json';
import pt from './pt.json';
import ro from './ro.json';
import ru from './ru.json';
import si from './si.json';
import sk from './sk.json';
import sl from './sl.json';
import so from './so.json';
import sq from './sq.json';
import sr from './sr.json';
import sv from './sv.json';
import sw from './sw.json';
import ta from './ta.json';
import te from './te.json';
import th from './th.json';
import tr from './tr.json';
import uk from './uk.json';
import ur from './ur.json';
import uz from './uz.json';
import vi from './vi.json';
import zh from './zh.json';
import zh_Hant from './zh-Hant.json';


const messages = {
  af,
  am,
  ar,
  az,
  bg,
  bn,
  bs,
  ca,
  cs,
  cy,
  da,
  de,
  el,
  en,
  es,
  et,
  fa,
  fi,
  fil,
  fr,
  ga,
  gu,
  ha,
  he,
  hi,
  hr,
  ht,
  hu,
  hy,
  id,
  is,
  it,
  ja,
  ka,
  kk,
  kn,
  ko,
  lv,
  mk,
  ml,
  mn,
  mr,
  ms,
  mt,
  nl,
  no,
  pa,
  pl,
  ps,
  pt,
  ro,
  ru,
  si,
  sk,
  sl,
  so,
  sq,
  sr,
  sv,
  sw,
  ta,
  te,
  th,
  tr,
  uk,
  ur,
  uz,
  vi,
  zh,
  zh_Hant,
}

const i18n = createI18n({
  locale: "en",
  fallbackLocale: 'en', // 如果当前环境不存在，则使用默认语言环境
  silentTranslationWarn: true, // 禁用缺失翻译警告
  missingWarn: false, // 禁用缺少翻译键的警告
  fallbackWarn: false, // 禁用回退警告
  legacy: false,
  messages,
  postTranslation: (str) => {
    var result = str.replace(/speakpal/g, 'germantutor')
    result = result.replace(/SpeakPal/g, 'GermanTutor')
    result = result.replace(/Speakpal/g, 'GermanTutor')
    result = result.replace(/speakPal/g, 'germanTutor')
    return result
  }
});

export default i18n
